import createIcon from '../../createIcon';

/**
 * @component @name MotionPhotosOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi44OCA3Ljg4TDQuNDIgOS40MkM0LjE1IDEwLjIzIDQgMTEuMSA0IDEyQzQgMTYuNDEgNy41OSAyMCAxMiAyMEMxNi40MSAyMCAyMCAxNi40MSAyMCAxMkMyMCA3LjU5IDE2LjQxIDQgMTIgNEMxMS4xIDQgMTAuMjMgNC4xNSA5LjQyIDQuNDJMNy44OSAyLjg5QzkuMTUgMi4zMiAxMC41NCAyIDEyIDJDMTcuNTIgMiAyMiA2LjQ4IDIyIDEyQzIyIDE3LjUyIDE3LjUyIDIyIDEyIDIyQzYuNDggMjIgMiAxNy41MiAyIDEyQzIgMTAuNTMgMi4zMiA5LjE0IDIuODggNy44OFpNNiAxMkM2IDguNjkgOC42OSA2IDEyIDZDMTUuMzEgNiAxOCA4LjY5IDE4IDEyQzE4IDE1LjMxIDE1LjMxIDE4IDEyIDE4QzguNjkgMTggNiAxNS4zMSA2IDEyWk03IDUuNUM3IDYuMzMgNi4zMyA3IDUuNSA3QzQuNjcgNyA0IDYuMzMgNCA1LjVDNCA0LjY3IDQuNjcgNCA1LjUgNEM2LjMzIDQgNyA0LjY3IDcgNS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MotionPhotosOn = createIcon('MotionPhotosOn', [
  [
    'path',
    {
      d: 'M2.88 7.88L4.42 9.42C4.15 10.23 4 11.1 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.1 4 10.23 4.15 9.42 4.42L7.89 2.89C9.15 2.32 10.54 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.53 2.32 9.14 2.88 7.88ZM6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12ZM7 5.5C7 6.33 6.33 7 5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5Z',
      key: '50z718',
    },
  ],
]);

export default MotionPhotosOn;
